import React from 'react'
import * as AppBar from 'components/AppBar'
import { compose } from 'recompose'
import withAuthorization from 'components/Session/withAuthorization'
import * as Auth from 'models/Auth'
import Base from './Base'
import Router from 'next/router'

const Component = ({ children, style, client }) => {
  const onLogout = async () => {
    await Auth.signout()
    client.resetStore()
    Router.push('/login')
  }

  return (
    <div>
      <AppBar.Admin onLogout={onLogout} />
      <Base style={style}> {children} </Base>
    </div>
  )
}

const ComposedComponent = compose(withAuthorization(true, 'admin'))(Component)

export default ComposedComponent
